import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import dracula from 'react-syntax-highlighter/dist/cjs/styles/prism/dracula';
import { codePreview, header as headerStyle } from './CodeSnippet.styles';

type Props = {
  header: string | React.ReactNode;
  code: string;
  language: string;
};

export const CodeSnippet: React.FC<Props> = ({ header, code, language }) => {
  return (
    <div>
      <div className={headerStyle}>{header}</div>
      <div className={codePreview}>
        <SyntaxHighlighter language={language} style={dracula}>
          {code}
        </SyntaxHighlighter>
      </div>
    </div>
  );
};
